export enum InPageAlertVariant {
  Info = "nsw-in-page-alert--info",
  Error = "nsw-in-page-alert--error",
  Warning = "nsw-in-page-alert--warning",
  Success = "nsw-in-page-alert--success",
}

export interface InPageAlertProps {
  variant: InPageAlertVariant;
  title?: string;
  message: string | JSX.Element;
  show: boolean;
  isCompact?: boolean;
}

function InPageAlert({
  variant,
  title,
  message,
  show,
  isCompact = true,
}: InPageAlertProps) {
  if (!show) {
    return null;
  }

  const alertClasses = `nsw-in-page-alert mb-3 ${variant} ${
    isCompact ? "nsw-in-page-alert--compact" : ""
  }`;

  return (
    <div className={alertClasses}>
      <i
        tabIndex={-1}
        aria-hidden="true"
        className="material-icons nsw-material-icons nsw-in-page-alert__icon"
      >
        {variant === InPageAlertVariant.Info
          ? "info"
          : variant === InPageAlertVariant.Error
          ? "cancel"
          : variant === InPageAlertVariant.Warning
          ? "error"
          : "check_circle"}
      </i>
      <div className="nsw-in-page-alert__content">
        {title && <p className="nsw-h5">{title}</p>}
        <div className={isCompact ? "nsw-small mb-0" : "mb-0"}>{message}</div>
      </div>
    </div>
  );
}

export default InPageAlert;
